import Web3Modal from "web3modal";
import {ethers} from "ethers";
import Market from "../../../contracts/NFTMarket.json";

export async function buyNft(address : string, priceI: number, nftmarketaddress: string, tokenID: string) {
    const web3Modal = new Web3Modal()
    const connection = await web3Modal.connect()
    const provider = new ethers.providers.Web3Provider(connection)
    const signer = provider.getSigner()

    const contract = new ethers.Contract(nftmarketaddress, Market.abi, signer)

    const price = ethers.utils.parseUnits(priceI.toString(), 'ether')
    const transaction = await contract.createMarketSale(address, tokenID, {
        value: price
    })
    return await transaction.wait()
}